<template>
  <div>
    <el-carousel
      :interval="5000"
      trigger="click"
      arrow="never"
      :height="bannerHeight + 'px'"
    >
      <el-carousel-item>
        <el-row :gutter="12">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" >
            <img
              ref="banner"
              :src="baseOSSUrl + '/banner.png'"
              alt=""
              @load="imgLoad"
              style="width: 100%"
              importance="high"
            >
          </el-col>
        </el-row>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>

import {
baseOSSUrl
} from '@/utils/oss';
export default {
  name: 'homeCarousel',
  data() {
    return {
      bannerHeight: 570,
      baseOSSUrl
    }
  },
  created(){
    window.addEventListener('resize',() => {
      this.imgLoad()
    },false)
  },
  methods: {
    imgLoad(){
      this.bannerHeight = this.$refs.banner ? this.$refs.banner.height : this.bannerHeight;
    }
  }
}
</script>

<style>

  .is-active .el-carousel__button::after{
    transition: left 2s;
    left: 0;
  }
</style>
